
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"24","height":"24"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"data-name":"Group 1937"}},[_c('path',{attrs:{"data-name":"Rectangle 2666","fill":"none","d":"M0 0h24v24H0z"}}),_c('g',{attrs:{"data-name":"Group 1936","fill":"#adadad"}},[_c('path',{attrs:{"data-name":"Path 1237","d":"M11.715 0a10 10 0 00-5.5 18.348V20a2.007 2.007 0 002 2h1.5a2 2 0 104 0h1.5a2.007 2.007 0 002-2v-1.652A10 10 0 0011.715 0zm4.4 16.679A2 2 0 0015.247 18h-7.06a2 2 0 00-.869-1.321 8 8 0 118.8 0z"}}),_c('g',{attrs:{"data-name":"Group 1935","transform":"translate(-352.458 -375.841)"}},[_c('path',{attrs:{"data-name":"Path 1238","d":"M369.173 385.589a1 1 0 01-.707-.293 6.069 6.069 0 00-8.586 0 1 1 0 11-1.414-1.414 8.068 8.068 0 0111.414 0 1 1 0 01-.707 1.707z"}}),_c('path',{attrs:{"data-name":"Path 1239","d":"M361.173 388.832a1 1 0 01-.707-1.707 5.241 5.241 0 017.414 0 1 1 0 01-1.414 1.414 3.32 3.32 0 00-4.586 0 1 1 0 01-.707.293z"}}),_c('circle',{attrs:{"data-name":"Ellipse 249","cx":"1","cy":"1","r":"1","transform":"translate(363.173 389.832)"}})])])])])
          )
        }
      }
    